module.exports = __webpack_public_path__ + "static/media/01-firma-don-alberto@2x.df5b8ab2.jpg";